import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import PageSectionsEdit from '../../../modules/pages/components/PageSectionsEdit';

export default function PageSections() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  dispatch(
    setBreadCrumbsData({
      links: [{ label: t('page_sections'), path: '/pages' }],
      page_title: t('page_sections')
    })
  );

  return (
    <div className='page_sections'>
      <PageSectionsEdit />
    </div>
  );
}
